import {
  Badge,
  Button,
  Popover,
  PopoverSurface,
  PopoverTrigger,
} from '@fluentui/react-components';

import { useEnvironmentBadgeStyles } from './EnvironmentBadge.style.js';

export interface EnvironmentBadgeProps {
  environment: string;
  webVersion: string;
  serviceVersion?: string;
  isServiceVersionLoading?: boolean;
}

function getEnvironmentLabel(environment: string): string {
  switch (environment.toLowerCase()) {
    case 'development':
    case 'localdev':
      return 'dev';
    case 'nonprod':
      return 'np';
    default:
      return environment;
  }
}

export function EnvironmentBadge({
  environment,
  webVersion,
  serviceVersion,
  isServiceVersionLoading = false,
}: EnvironmentBadgeProps) {
  const styles = useEnvironmentBadgeStyles();
  const label = getEnvironmentLabel(environment);

  return (
    <Popover positioning="below-start">
      <PopoverTrigger disableButtonEnhancement>
        <Button
          appearance="transparent"
          className={styles.trigger}
          aria-label={`Show deployment details for ${label.toUpperCase()}`}
        >
          <Badge
            appearance="tint"
            color="subtle"
            size="small"
            className={styles.badge}
          >
            {label}
          </Badge>
        </Button>
      </PopoverTrigger>
      <PopoverSurface>
        <div className={styles.versions}>
          <span>Web: {webVersion}</span>
          <span>
            Service:{' '}
            {isServiceVersionLoading
              ? 'Loading...'
              : (serviceVersion ?? 'Unavailable')}
          </span>
        </div>
      </PopoverSurface>
    </Popover>
  );
}
